// extracted by mini-css-extract-plugin
export var changeBox = "recipe-ingredient-module--changeBox--FuLSm";
export var changeButton = "recipe-ingredient-module--change-button--r8VF-";
export var content = "recipe-ingredient-module--content--Q9B+m";
export var dropdown = "recipe-ingredient-module--dropdown--My55j";
export var replacement = "recipe-ingredient-module--replacement--RvkR7";
export var replacementButton = "recipe-ingredient-module--replacement-button--Sjmoj";
export var simple = "recipe-ingredient-module--simple--QEpsV";
export var wrapper = "recipe-ingredient-module--wrapper--MZs4n";